import { actionCreators as FeedItemActionCreators } from '@app/components/FeedItem/modules/feedItems'
import { externalActionCreators as SignTransferActionCreators } from '@app/components/SignTransferModal/modules/signTransfer'
import { siteRoutingActionCreators } from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import PropertyPage from '../components/PropertyPage'
import {
  actionCreators,
  IPropertyState,
  selectAssignments,
  selectError,
  selectIncludeArchived,
  selectIncludeCompletedAssignments,
  selectIsDeleting,
  selectIsLoading,
  selectIsLoadingAssignments,
  selectPermissions,
  selectProperty,
  selectShowConfirmDelete,
} from '../modules/property'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IPropertyState & ICurrentUserState
    >({
      assignments: selectAssignments(),
      error: selectError(),
      includeArchivedLeads: selectIncludeArchived(),
      includeCompletedAssignments: selectIncludeCompletedAssignments(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      isLoadingAssignments: selectIsLoadingAssignments(),
      permissions: selectPermissions(),
      property: selectProperty(),
      showConfirmDelete: selectShowConfirmDelete(),
      user: selectCurrentUser(),
    }),
    {
      ...actionCreators,
      ...FeedItemActionCreators,
      ...siteRoutingActionCreators,
      ...SignTransferActionCreators,
    },
  )(PropertyPage),
)
